<ng-template #confirmLocationModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Search Location</h4>
    <button type="button" class="btn-close" aria-label="Close" title="Close Modal" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="search-location-block">
      <confirm-google-location [location]="initialLocation" (selectionChange)="selectedLocation = $event"></confirm-google-location>
      <h5 class="location-title">Search Location</h5>
      <ul class="location-list" *ngIf="selectedLocation">
        <li class="active">
          <img src="./assets/images/ic-location-select.svg" alt="Icon">
          <p>{{ selectedLocation.address }}</p>
        </li>
      </ul>
      <div class="btn-grps">
        <app-button [btnText]="'Confirm Location'" [btnTitle]="'Confirm Location'" [btnCss]="'btn btn-primary w-100 btn-lg'"
                    [isDisable]="!selectedLocation?.address" (onBtnClick)="confirm(modal)"></app-button>
      </div>
    </div>
  </div>
</ng-template>
